/**
 * Slideshow con enlaces independientes por imagen.
 * Usa scroll-snap nativo para el swipe (mejor rendimiento en mÃ³vil)
 * y JavaScript solo para: autoplay, flechas, puntos y accesibilidad.
 */
(function () {
  'use strict';

  function initSlideshow(root) {
    if (!root || root.dataset.slwInit === 'true') return;
    root.dataset.slwInit = 'true';

    var track = root.querySelector('[data-track]');
    var viewport = root.querySelector('.slw__viewport');
    var isAutoHeight = root.classList.contains('slw--auto');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    if (!track || slides.length === 0) return;

    var total = slides.length;
    var currentIndex = 0;
    var autoplayEnabled = root.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    var autoplayTimer = null;
    var prefersReducedMotion = window.matchMedia('(prefers-reduce-motion: reduce)').matches
      || window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Modo "AutomÃ¡tica": ajusta la altura del contenedor a la foto que
       se estÃ© mostrando en cada momento, manteniendo siempre el 100%
       del ancho del dispositivo y la proporciÃ³n real de esa imagen. */
    function setViewportHeight(index) {
      if (!isAutoHeight || !viewport) return;
      var slide = slides[index];
      if (!slide) return;
      var media = slide.querySelector('img.slw__img') || slide.querySelector('.slw__picture');
      if (!media) return;
      var h = media.getBoundingClientRect().height;
      if (h > 0) {
        viewport.style.height = Math.round(h) + 'px';
      }
    }

    function goTo(index, behavior) {
      var target = (index + total) % total;
      var slide = slides[target];
      setViewportHeight(target);
      track.scrollTo({
        left: slide.offsetLeft,
        behavior: behavior || 'smooth'
      });
    }

    function updateActive(index) {
      currentIndex = index;
      setViewportHeight(index);
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    /* Detecta quÃ© diapositiva estÃ¡ visible tras un swipe o scroll manual */
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            var idx = parseInt(entry.target.dataset.index, 10);
            updateActive(idx);
          }
        });
      },
      { root: track, threshold: [0.6] }
    );
    slides.forEach(function (slide) { observer.observe(slide); });

    /* Flechas */
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stopAutoplay();
        goTo(currentIndex + 1);
        restartAutoplay();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stopAutoplay();
        goTo(currentIndex - 1);
        restartAutoplay();
      });
    }

    /* Puntos */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stopAutoplay();
        goTo(parseInt(dot.dataset.goto, 10));
        restartAutoplay();
      });
    });

    /* Autoplay */
    function startAutoplay() {
      if (!autoplayEnabled || total <= 1 || prefersReducedMotion) return;
      autoplayTimer = setInterval(function () {
        goTo(currentIndex + 1);
      }, autoplaySpeed);
    }
    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }
    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    /* Pausa el autoplay si el usuario interactÃºa (hover, foco, toque) */
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (evt) {
      root.addEventListener(evt, stopAutoplay, { passive: true });
    });
    ['mouseleave', 'focusout', 'touchend'].forEach(function (evt) {
      root.addEventListener(evt, restartAutoplay, { passive: true });
    });

    /* Pausa el autoplay cuando la secciÃ³n no estÃ¡ en pantalla (rendimiento) */
    var visibilityObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          startAutoplay();
        } else {
          stopAutoplay();
        }
      });
    }, { threshold: 0.1 });
    visibilityObserver.observe(root);

    /* Teclado: accesibilidad con flechas izquierda/derecha */
    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { stopAutoplay(); goTo(currentIndex + 1); restartAutoplay(); }
      if (e.key === 'ArrowLeft') { stopAutoplay(); goTo(currentIndex - 1); restartAutoplay(); }
    });

    /* Recalcula la altura si cambia el ancho disponible (rotar el mÃ³vil,
       redimensionar la ventana, o abrir/cerrar el editor del tema) */
    if (isAutoHeight) {
      setViewportHeight(0);
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          setViewportHeight(currentIndex);
        }, 150);
      });
      /* Ajusta la altura en cuanto la imagen activa termine de cargar
         (evita quedarse con una altura provisional a 0) */
      var firstMedia = slides[0] && slides[0].querySelector('img.slw__img');
      if (firstMedia) {
        if (firstMedia.complete) {
          setViewportHeight(0);
        } else {
          firstMedia.addEventListener('load', function () { setViewportHeight(0); }, { once: true });
        }
      }
    }

    startAutoplay();
  }

  window.SlwSlideshow = {
    init: initSlideshow
  };

  /* Auto-inicializaciÃ³n de todas las instancias presentes en la pÃ¡gina */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
  });
})();